import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { LabelSmall } from 'baseui/typography';
import { memo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAsset, FleetAssetDocumentList, FleetAssetDocumentType } from '../../../types/fleet';
import { getAssetTitle } from '../../../utils/assets';
import FleetAssetDocumentForm from './FleetAssetDocumentForm';
import FleetAssetDocumentResume from './FleetAssetDocumentResume';

type Props = {
  isOpen: boolean;
  selectedAsset: FleetAsset;
  selectedDocument: FleetAssetDocumentType;
  documents?: FleetAssetDocumentList;
  onClose: (update?: boolean) => void;
};

function FleetAssetDocumentModal({ onClose, isOpen, selectedAsset, documents, selectedDocument }: Props) {
  const { css } = useStyles();
  const documentData = documents?.[selectedDocument];
  const [edit, setEdit] = useState(!documentData);
  const assetLabel = `${getAssetTitle(selectedAsset)} (${selectedAsset.label})`;
  const title = (() => {
    if (selectedDocument === FleetAssetDocumentType.emissionsTest) return 'Verificación vehicular';
    if (selectedDocument === FleetAssetDocumentType.insurancePolicy) return 'Póliza';
    return 'Tarjeta de circulación';
  })();

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
            maxWidth: '560px',
          })}
        >
          <FlexColumn gap={0}>
            {title}
            <LabelSmall>{assetLabel}</LabelSmall>
          </FlexColumn>
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          {edit && (
            <FleetAssetDocumentForm
              asset={selectedAsset}
              onCancel={() => (documentData ? setEdit(false) : onClose(false))}
              selectedDocument={selectedDocument}
              documents={documents}
              afterSave={() => onClose(true)}
            />
          )}
          {!edit && documentData && (
            <FleetAssetDocumentResume
              documentData={documentData}
              onClose={onClose}
              onEdit={() => setEdit(true)}
            />
          )}
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetAssetDocumentModal);
